module.exports = __webpack_public_path__ + "media/images/logo-f21a6123.svg";